import { makeStyles } from '@fluentui/react-components';

export const useContainerBrowserStyles = makeStyles({
    loadingContainer: {
        padding: '20px',
    },
    skeletonWrapper: {
        marginBottom: '20px',
    },
    skeletonItem: {
        marginBottom: '10px',
    },
    actionsCell: {
        justifyContent: 'flex-end',
    },
});
